import { useTranslation } from "react-i18next";
import {
  Heading,
  PageContainer
} from "@ifrc-go/ui"
import { _cs } from "@togglecorp/fujs";

import styles from "./styles.module.css";

const appVersion = import.meta.env.APP_VERSION;

interface Props {
  className?: string;
}

function GlobalFooter(props: Props) {
  const { className } = props;
  const { t }= useTranslation();

  return (
    <PageContainer
      className={_cs(styles.footer, className)}
      contentClassName={styles.content}
      containerAs="footer"
    >
      <div className={styles.section}>
        <Heading>
          {t("globalFooter.heading")}
        </Heading>
        <div className={styles.description}>
          {t("globalFooter.description")}
        </div>
        <div className={styles.copyright}>
        {t("globalFooter.copyright", { appVersion })}
        </div>
      </div>
    </PageContainer>
  );
}

export default GlobalFooter;
